import { render, staticRenderFns } from "./MLoginHeader.vue?vue&type=template&id=65d5e54d&scoped=true&"
import script from "./MLoginHeader.vue?vue&type=script&lang=ts&"
export * from "./MLoginHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5e54d",
  null
  
)

export default component.exports